import { Input } from "reactstrap";
import {
  ClientAdvanceSourceType,
  ClientAdvanceSourceTypeLabel,
  ClientAdvanceStatus,
  clientAdvanceStatusMap,
} from "features/ClientAdvances/constants/client-advance.constants";

type Props = {
  status: string;
  onStatusChange: (value: string) => void;
  sourceType: string;
  onSourceTypeChange: (value: string) => void;
};

export default function ClientAdvanceListFilters({
  status,
  onStatusChange,
  sourceType,
  onSourceTypeChange,
}: Props) {
  return (
    <div className="d-flex align-items-center gap-2">
      <Input
        type="select"
        className="form-select"
        style={{ width: 160 }}
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {(Object.values(ClientAdvanceStatus) as ClientAdvanceStatus[]).map((s) => (
          <option key={s} value={s}>
            {clientAdvanceStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>

      <Input
        type="select"
        className="form-select"
        style={{ width: 160 }}
        value={sourceType}
        onChange={(e) => onSourceTypeChange(e.target.value)}
      >
        <option value="">All sources</option>
        {(Object.values(ClientAdvanceSourceType) as ClientAdvanceSourceType[]).map((t) => (
          <option key={t} value={t}>
            {ClientAdvanceSourceTypeLabel[t] ?? t}
          </option>
        ))}
      </Input>
    </div>
  );
}
